import React from 'react';
import headerImg from '../../media/header_img.png';
import '../../styles/header.css';

function Header() {
    return (
        <header className="header">
            {/* logo returns to the nlpbegin overview (the neuron map on barinderthind.com) */}
            <a href="/#sp-nlpbegin" aria-label="back to the nlpbegin overview">
                <img src={headerImg} alt="Logo" className="logo"/>
            </a>
        </header>
    );
}

export default Header;
